import React, { useState, Suspense } from "react";
import emailjs from "@emailjs/browser";
import { Canvas } from "@react-three/fiber";
import { Loader } from "../components";
import { Fox } from "../models";
import useAlert from "../hooks/useAlert";
import { Alert } from "../components";
import { Link } from "react-router-dom";
import { socialLinks } from "../constants";

const Contact = () => {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [loading, setLoading] = useState(false);
  const [currentAnimation, setCurrentAnimation] = useState("idle");
  const { alert, showAlert, hideAlert } = useAlert();

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };
  const handleFocus = () => {
    setCurrentAnimation("walk");
  };
  const handleBlur = () => {
    setCurrentAnimation("idle");
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    setCurrentAnimation("hit");
    emailjs
      .send(
        "service_viu8ggx",
        "template_oe4rc4m",
        {
          from_name: form.name,
          to_name: "Adarsh",
          from_email: form.email,
          to_email: "adarshsahu1996@gmail.com",
          message: form.message,
        },
        { publicKey: "hca76dGmlxv-EpmQd" }
      )
      .then(() => {
        setLoading(false);
        showAlert({
          show: true,
          text: "Message sent successfully",
          type: "success",
        });
        setTimeout(() => {
          hideAlert();
          setForm({ name: "", email: "", message: "" });
          setCurrentAnimation("idle");
        }, 3000);
      })
      .catch(() => {
        setLoading(false);
        showAlert({
          show: true,
          text: "I didn't get your message. Please try again",
          type: "danger",
        });
        setCurrentAnimation("idle");
        //todo show error
      });
  };

  return (
    <section className="relative flex lg:flex-row flex-col max-container h-[100vh] ">
      {alert.show && <Alert {...alert} />}
      <div className="flex-1 min-w-[50%] flex flex-col">
        <h1 className="head-text">Get in Touch</h1>
        <div className="flex justify-start mt-5">
          {socialLinks.map((link) => (
            <div className="ml-5 text-center">
              <Link
                to={link.link}
                target="_blank"
                className=" flex flex-col justify-center items-center"
              >
                <img
                  className="w-10 h-10"
                  src={link.iconUrl}
                  alt={link.name}
                ></img>
                {link.name}
              </Link>
            </div>
          ))}
        </div>
        <form
          action=""
          className="w-full flex flex-col gap-7 mt-14"
          onSubmit={handleSubmit}
        >
          <label htmlFor="" className="text-black-500 font-semibold">
            Name
            <input
              type="text"
              name="name"
              className="input"
              placeholder="John Doe"
              required
              value={form.name}
              onChange={handleChange}
              onFocus={handleFocus}
              onBlur={handleBlur}
            />
          </label>
          <label htmlFor="" className="text-black-500 font-semibold">
            Email
            <input
              type="email"
              name="email"
              className="input"
              placeholder="john@gmail.com"
              required
              value={form.email}
              onChange={handleChange}
              onFocus={handleFocus}
              onBlur={handleBlur}
            />
          </label>
          <label htmlFor="" className="text-black-500 font-semibold">
            Your Message
            <textarea
              type="text"
              name="message"
              className="input"
              placeholder="Let me know how I can help you"
              required
              value={form.message}
              onChange={handleChange}
              onFocus={handleFocus}
              onBlur={handleBlur}
            />
          </label>
          <button
            type="submit"
            className="btn"
            disabled={loading}
            onFocus={handleFocus}
            onBlur={handleBlur}
          >
            {loading ? "Sending..." : "Send Message"}
          </button>
        </form>
      </div>
      <div className="lg:w-1/2 w-full lg:h-auto md:h-[550px] h-[350px]">
        <Canvas
          camera={{
            position: [0, 0, 5],
            fav: 75,
            near: 0.1,
            far: 1000,
          }}
        >
          <directionalLight intensity={2.5} position={[0, 0, 1]} />
          <ambientLight intensity={0.5} />
          <Suspense fallback={<Loader />}>
            <Fox
              currentAnimation={currentAnimation}
              position={[0.5, 0.35, 0.5]}
              rotation={[12.6, -0.6, 0]}
              scale={[0.5, 0.5, 0.5]}
            />
          </Suspense>
        </Canvas>
      </div>
    </section>
  );
};

export default Contact;
